import React from "react";
import TheWorld from "../../TheWorld";
import HeroSection from "../../HeroSection";


function Home() {
    return (
        <>
            <TheWorld/>
        </>
    );
}

export default Home;
